import useStoreSelector from "common/redux/useStoreSelector";
import { Producer } from "./producer";
import producerService from "./producerService";
import _ from "lodash";
import { useEffect, useState } from "react";

const getCached = _.memoize(async () => {
    return await producerService.getMyProducer();
});

export default function useMyProducer(): Producer
{
    const [producer, setProducer] = useState<Producer>(null);
    const isCustomer = useStoreSelector(m => m.userState.isCustomer);

    useEffect(() => { 
        if (!isCustomer) return;

        getCached().then(setProducer);
    }, [isCustomer])

    return producer;

}